import React from 'react';
import TourOverViewEntityAccordion from './TourOverViewEntityAccordion';

const TourOverViewEntityList = ({ items }) => {
  if (!items || !items.length) return null;

  return (
    <>
      {items.map((item, index) => (
        <TourOverViewEntityAccordion
          key={`${item.config?.type}-${index}`}
          item={item}
          config={item.config}
          iconColor={item.config?.color}
        />
      ))}
    </>
  );
};

export default TourOverViewEntityList;